import React from "react";
import { formatInstallationTime } from "../../../../utils/helpers";
import { dateFormatter } from "../../../components/tables/table";

const ProductContent = ({ product }) => {
  if (!product) return <></>;
  return (
    <>
      <div className="row d-flex align-items-center">
        <div className="col-md-4">
          <h5>Descripción</h5>
          <p>{product?.descripcion}</p>
        </div>
        <div className="col-md-4">
          <h5>Referencia</h5>
          <p>{product?.referencia}</p>
        </div>
        <div className="col-md-4">
          <h5>Familia</h5>
          <p>{product?.familia?.descripcion}</p>
        </div>
      </div>
      <div className="row d-flex align-items-center">
        <div className="col-md-4">
          <h5>Marca</h5>
          <p>{product?.marca?.nombre || "---"}</p>
        </div>
        <div className="col-md-4">
          <h5>Tipo</h5>
          <p>{product?.tipo_producto?.descripcion}</p>
        </div>
        <div className="col-md-4">
          <h5>Precio</h5>
          <p>{product?.precio + " €"}</p>
        </div>
      </div>
      <div className="row d-flex align-items-center">
        <div className="col-md-4">
          <h5>Tipo de Unidad</h5>
          <p>{product?.tipo_unidad?.descripcion}</p>
        </div>
        <div className="col-md-4">
          <h5>Tiempo instalación (hh:mm)</h5>
          <p>{formatInstallationTime(product?.tiempo_instalacion) || "---"}</p>
        </div>
        <div className="col-md-4">
          <h5>Descuento base</h5>
          <p>{product?.descuento_base || "---"}</p>
        </div>
      </div>
      <div className="row d-flex align-items-center">
        <div className="col-md-4">
          <h5>Fecha Alta</h5>
          <p>{dateFormatter(product?.fecha_alta) + "h"}</p>
        </div>
      </div>
    </>
  );
};

export default ProductContent;
